import { formValues } from 'redux-form';

import { Snapcodes } from './Snapcodes';

export const SnapcodesContainer = formValues<any, any>('snapchat')(Snapcodes);
